module.exports = __webpack_public_path__ + "img/dmca_protected_16_120.3d408b4.webp";